import QuickJump from './QuickJump';
export default QuickJump;
